var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.alertComp,"type":_vm.type,"dark":"","transition":"scale-transition","dismissible":""},on:{"input":_vm.inputAlert}},[(_vm.value && _vm.value.length > 0)?_c('div',_vm._l((_vm.value),function(item,i){return _c('div',{key:i},[_vm._v(_vm._s(item))])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }